import React from 'react'
import ContactMain from '../components/ContactMain/ContactMain'
import ContactSection from '../components/ContactSection/ContactSection'
import ContactBanner from '../components/ContactBanner/ContactBanner'
import AyurvedaFooter from '../components/AyurvedaFooter/AyurvedaFooter'
import ScrollToTop from '../components/ScrollToTop'
import WhatsAppButton from "../components/WhatsAppButton";
import ScrollTop from '../components/ScrollTop'
import { Helmet } from 'react-helmet-async';

export default function Contact() {
  return (
    <>
 <Helmet>
  <title>
    Contact Us | Ayurmoksha Ayurveda Clinic | Kerala
  </title>

  <meta
    name="description"
    content="Get in touch with Ayurmoksha Ayurveda Hospital in Kozhikode, Kerala. Contact us to book consultations for Postnatal Care, Rejuvenation Therapy, Hair Treatment, Lifestyle Guidance & Yoga, and Soundarya Kalpa. Experience authentic Ayurvedic healing in a peaceful, nature-inspired environment."
  />

  <meta
    name="keywords"
    content="Contact Ayurmoksha, Ayurmoksha Ayurveda Clinic Contact, Ayurveda Hospital Kozhikode Contact, Ayurveda Hospital Calicut, Ayurvedic Treatment Booking Kerala, Postnatal Care Ayurveda Contact, Rejuvenation Therapy Kerala Contact, Hair Treatment Ayurveda Contact, Lifestyle Guidance Ayurveda Kerala, Soundarya Kalpa Contact"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://ayurmoksha.in/contact" />

  {/* Open Graph Meta */}
  <meta property="og:locale" content="en_IN" />
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Contact Ayurmoksha Ayurveda Hospital | Kozhikode Kerala"
  />
  <meta
    property="og:description"
    content="Contact Ayurmoksha Ayurveda Hospital in Kozhikode, Kerala to schedule consultations and Ayurvedic treatments. Reach out for holistic healing rooted in traditional Ayurveda."
  />
  <meta
    property="og:url"
    content="https://ayurmoksha.in/contact"
  />
  <meta
    property="og:site_name"
    content="Ayurmoksha Ayurveda Hospital"
  />
  <meta
    property="og:image"
    content="https://ayurmoksha.in/logo.webp"
  />
  <meta
    property="og:image:alt"
    content="Contact Ayurmoksha Ayurveda Hospital in Kozhikode Kerala"
  />

  <meta name="author" content="Ayurmoksha Ayurveda Hospital" />
</Helmet>

    <div>
      <ScrollTop/>
        <ContactMain/>
        <ContactSection/>
        <ContactBanner/>
        <AyurvedaFooter/>
        <ScrollToTop/>
         <WhatsAppButton />
    </div>
    </>
  )
}
